/**
 * @file 内容区
 */
import { Pagination, Spin, Button, Select } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { useData, useFilter } from './hooks';
import { Card } from './card';
import { useWallet } from '@/hooks/wallet';
import { DAppsIcon } from '@bfe/moly-icons';
import { NoSSR } from '@web3/base-components';
import styles from './index.module.scss';
import EmptyIcon from '@/assets/images/empty.svg';

export const Content = () => {
  const fm = useFm();
  const { data, isLoading, pageNo, pageSize, onChangePageNo } = useData();
  const { filterData, currentPool, onChangePool, filterList } = useFilter(data);
  const { openLoginModal, isLogin } = useWallet();

  return (
    <div className={styles.container}>
      <div className={styles.titleArea}>
        <div className={styles.titleText}>{fm('investedProjects')}</div>
        <div className={styles.filterArea}>
          <div className={styles.filterIconWrap}>
            <DAppsIcon className={styles.filterIcon} />
          </div>
          <NoSSR>
            <div className={styles.select}>
              <Select
                width="max-content"
                value={currentPool}
                onChange={(v) => {
                  onChangePageNo(1);
                  onChangePool(v as string);
                }}
                size="xs"
                options={filterList}
                dropdownClassName={styles.selectOptions}
              />
            </div>
          </NoSSR>
        </div>
      </div>
      {!isLogin && (
        <div className={styles.tipArea}>
          <EmptyIcon alt="" />
          <div className={styles.tipText}>
            {fm('connectOrLoginBybitWallet')}
          </div>
          <Button
            variant="primary"
            onClick={openLoginModal}
            className={styles.connectModal}
          >
            {fm('connect_wallet')}
          </Button>
        </div>
      )}
      {isLogin && (
        <>
          {isLoading && (
            <div className={styles.tipArea}>
              <Spin />
            </div>
          )}
          {!isLoading && (
            <>
              {filterData.length > 0 && (
                <>
                  {filterData
                    .slice((pageNo - 1) * pageSize, pageNo * pageSize)
                    .map((item) => {
                      return <Card data={item} key={item.poolId} />;
                    })}
                  {
                    <div className={styles.pagination}>
                      <Pagination
                        current={pageNo}
                        total={filterData.length}
                        pageSize={pageSize}
                        onChange={onChangePageNo}
                      />
                    </div>
                  }
                </>
              )}
              {filterData.length === 0 && (
                <div className={styles.tipArea}>
                  <EmptyIcon alt="" />
                  <div className={styles.tipText}>{fm('no_data')}</div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};
